import React from "react";
import { AVAILABILITY_TYPES } from "~/src/consts";
import { RotaSelect, RotaCheckbox, RotaDivider } from "@teamrota/rota-design";
import { DayRow, DayLabel, SelectWrapper, DividerContainer } from "./style";

const DAYS_OF_WEEK = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
];

const DAY_TYPE_OPTIONS = [
  { value: AVAILABILITY_TYPES.DAY, label: "Day" },
  { value: AVAILABILITY_TYPES.NIGHT, label: "Night" },
  { value: AVAILABILITY_TYPES.ALL, label: "Day & Night" }
];

const DaySelector = ({
  selectedDays,
  workDays,
  onToggleDay,
  onDayTypeChange
}) => {
  return (
    <>
      {DAYS_OF_WEEK.map(day => (
        <DayRow key={day} selected={selectedDays[day]}>
          <RotaCheckbox
            isChecked={selectedDays[day] || false}
            onClick={() => onToggleDay(day)}
          />
          <DayLabel>{day}</DayLabel>
          <SelectWrapper>
            <RotaSelect
              value={workDays[day] || AVAILABILITY_TYPES.DAY}
              onChange={e => onDayTypeChange(day, e.target.value)}
              disabled={!selectedDays[day]}
            >
              {DAY_TYPE_OPTIONS.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </RotaSelect>
          </SelectWrapper>
        </DayRow>
      ))}
      <DividerContainer>
        <RotaDivider />
      </DividerContainer>
    </>
  );
};

export default DaySelector;
